<template>
  <svg viewBox="0 0 41 41" xmlns="http://www.w3.org/2000/svg">
    <title>Pinterest</title>
    <g fill="none" fill-rule="evenodd">
      <g transform="translate(1 1)">
        <circle stroke="#162022" cx="19.5" cy="19.5" r="19.5" />
      </g>
      <path
        d="M16.193 20.781c.023-.056.253-.922.27-.98-.36-.53-.76-2.264-.454-3.67.331-2.066 2.57-3.08 4.685-3.08v-.005c2.647.002 4.628 1.441 4.63 3.92.002 1.94-1.194 4.504-3.236 4.504h-.002c-.729 0-1.651-.323-1.893-.64-.28-.366-.348-.817-.2-1.3.36-1.127.822-2.478.876-3.38.05-.85-.568-1.402-1.368-1.402-.603 0-1.385.342-1.775 1.302-.323.799-.316 1.634.02 2.555.132.36-.58 2.707-.809 3.47-.567 1.899-1.343 4.3-1.177 5.638L15.92 29l.805-1.03c1.113-1.425 2.265-5.11 2.572-6.006.907 1.147 2.796 1.18 3.016 1.18 2.705 0 5.772-2.624 5.685-6.277C27.922 13.663 25.523 11 21.211 11v.004c-4.1 0-6.494 2.139-7.08 4.841-.536 2.506.657 4.413 2.062 4.936Z"
        fill="#162022"
        fill-rule="nonzero"
      />
    </g>
  </svg>
</template>
